import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/upload-cloud-02.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M11 21V14.4141L8.70703 16.707C8.31651 17.0976 7.68349 17.0976 7.29297 16.707C6.90244 16.3165 6.90244 15.6835 7.29297 15.293L11.293 11.293L11.3691 11.2246C11.7619 10.9043 12.3409 10.9269 12.707 11.293L16.707 15.293L16.7754 15.3691C17.0957 15.7619 17.0731 16.3409 16.707 16.707C16.3409 17.0731 15.7619 17.0957 15.3691 16.7754L15.293 16.707L13 14.4141V21C13 21.5523 12.5523 22 12 22C11.4477 22 11 21.5523 11 21ZM1 10.5C1 5.80558 4.80558 2 9.5 2C12.5451 2 15.2139 3.60241 16.7139 6.00488C20.2047 6.11775 23 8.98173 23 12.5C23 14.5188 22.0783 16.3231 20.6367 17.5137C20.2109 17.8654 19.5802 17.8057 19.2285 17.3799C18.8769 16.954 18.9375 16.3233 19.3633 15.9717L19.5469 15.8115C20.4416 14.9879 21 13.8096 21 12.5C21 10.0147 18.9853 8 16.5 8C15.9363 8 15.3997 7.70597 15.1045 7.20508C13.9727 5.28479 11.8858 4 9.5 4C5.91015 4 3 6.91015 3 10.5C3 12.179 3.63518 13.7082 4.68066 14.8623L4.89551 15.0879L4.96387 15.1641C5.28336 15.5574 5.25931 16.1366 4.89258 16.502C4.50133 16.8917 3.86829 16.8902 3.47852 16.499C1.948 14.9628 1 12.8412 1 10.5Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as UploadCloud02Icon };
